import React from 'react';
import { HandCoins, Landmark } from 'lucide-react';
import { formatCustomNumber } from '../../helpers/formatCustomNumber';

// Reusable Component for a single stat item
export const BankingStatItem = ({ icon: Icon, iconColor, iconBg, label, value }) => {
  return (
    <div className="flex items-center gap-4">
      {/* Icon Container */}
      <div className={`flex h-12 w-12 items-center justify-center rounded-xl ${iconBg} ${iconColor}`}>
        <Icon size={24} strokeWidth={2} />
      </div>
      
      {/* Text Content */}
      <div className="flex flex-col">
        <span className="text-sm font-medium text-gray-600">
          {label}
        </span>
        <span className="text-xl font-bold text-gray-900">
          {formatCustomNumber(value)}
        </span>
      </div>
    </div>
  );
};